import React from "react";

export default function SectionCard({ title, children, styles, className }) {
  return (
    <div className={className || styles?.sectionCard}>
      <h3 className={styles?.sectionHeader}>{title}</h3>
      {children}
    </div>
  );
}
